// extracted by mini-css-extract-plugin
export default {"modalBox":"QuantityRestriction_modalBox__aD7oA"};